import FormProjectNew from "../../components/forms/FormProjectNew/FormProjectNew";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import {
  useFetchRolesQuery,
  useFetchSitesQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageProjectCreate = () => {
  const { data: sitesData } = useFetchSitesQuery();
  const { data: usersData } = useFetchUsersForFieldQuery("");
  const { data: rolesData } = useFetchRolesQuery();

  return (
    <PageLayout>
      <Breadcrumbs pageName="newProject" />
      <FormProjectNew
        sites={sitesData?.results}
        users={usersData}
        roles={rolesData?.results}
      />
    </PageLayout>
  );
};

export default PageProjectCreate;
